<template>
  <div id="container">
    <van-row class="info">
      <van-col span="4">
        <van-image
          round
          width="100%"
          :src="weiUser.headimgurl"
        />
      </van-col>
      <van-col offset="2" span="14">
        <h4>{{weiUser.nickname}}</h4>
        <h5>{{weiUser.cus_company_name}}</h5>
      </van-col>
      <van-col v-if="weiUser.cusUser!==undefined" span="4">
        <van-icon name="qr" size="40" class="margin-tb-10" @click="openQr()" />
      </van-col>
    </van-row>
    <van-cell-group class="margin-tb-10">
      <van-cell title="基本资料" is-link url="/wei/user/modify" />
      <van-cell title="收货地址" is-link url="/cus/user/modify" />
      <van-cell title="我的钱包" is-link url="/wallet" />
      <van-cell title="市场交易" is-link url="/trade" />
      <van-cell title="许愿单" is-link url="/wishlist" />
    </van-cell-group>
    <van-cell-group class="margin-tb-10">
      <van-cell title="历史需求" is-link url="/sal/order/models" />
      <van-cell title="预缴押金" is-link url="/sal/pledge/models" />
      <van-cell title="认证申请" is-link url="/verifies" />
    </van-cell-group>
    <van-cell-group>
      <van-cell title="系统设置" is-link url="/set" />
      <van-cell title="解除绑定" @click="unbind" />
    </van-cell-group>
    <div class="text-center bg-white margin-tb-10 padding-10">
      <!-- 客服电话：022-87891038<br/> -->
      版本号：V1.0.0
    </div>
    <TabBar :active="2"/>
  </div>
</template>

<script>
import Api from '@/utils/api'
import TabBar from '@/components/TabBar.vue'
export default {
  components: {
    TabBar
  },
  created () {
    this.reload()
  },
  data () {
    return {
      weiUser: {},
      cusCompany: {}
    }
  },
  methods: {
    reload () {
      Api.post('wei.user/model', null, res => {
        if (res.data.headimgurl === '') res.data.headimgurl = require('@/assets/avatar.png')
        this.weiUser = res.data
      })
    },
    unbind () {
      var self = this
      this.$dialog.confirm({title: '提示', message: '确认解除绑定吗？'})
        .then(() => {
          Api.post('cus.user/unbind', null, res => {
            self.$toast.success('操作成功')
          })
        })
    },
    openQr (model) {
      this.$router.push('/Qrcode')
    }
  }
}
</script>

<style scoped>
#container{background-color:#f1f1f1;padding-top:10px}
.info{background-color:#fff;margin-bottom:10px;padding:10px}
</style>



// WEBPACK FOOTER //
// src/pages/Mine.vue